<template>
  <v-container fluid class="px-0">
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <v-form ref="domainIndustryForm">
            <v-switch :label="`Do you hold trainings expertise specific to an industry? ${computeDomainIndustry}`"
            color="primary" v-model="domainIndustrySwitch"></v-switch>
            <v-text-field v-show="domainIndustrySwitch" v-model="profile.domainIndustry" name="domainIndustry" label="Please specify the industry(s)" :rules="rules.isRequired" box required>
            </v-text-field>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'DomainIndustryForm',
  props: ['save'],
  mounted () {
    if (this.profile.domainIndustry !== null && this.profile.domainIndustry !== '') {
      this.domainIndustrySwitch = true
    }
  },
  data () {
    return {
      domainIndustrySwitch: false,
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ]
      }
    }
  },
  computed: {
    ...mapState('profile', {
      profile: 'profile'
    }),
    computeDomainIndustry () {
      if (this.domainIndustrySwitch) return 'YES'
      return 'NO'
    }
  },
  watch: {
    save (value) {
      if (this.save) {
        this.saveDomainIndustry()
      }
    },
    domainIndustrySwitch (value) {
      this.profile.domainIndustry = Store.state.profile.profile.domainIndustry
      if (this.profile.domainIndustry === '') {
        this.$refs.domainIndustryForm.reset()
      }
    }
  },
  methods: {
    saveDomainIndustry () {
      if (this.domainIndustrySwitch) {
        if (this.$refs.domainIndustryForm.validate()) {
          const profile = { ...this.profile }
          Store.dispatch('profile/saveProfile', profile).then(
            () => this.$emit('resetSave', true)
          )
        } else {
          this.$emit('resetSave', false)
        }
      } else {
        this.$emit('resetSave', true)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/DomainIndustryForm.vue